import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
// import Sales from "../views/SalesUpdate.vue";
import Logout from '../views/Logout.vue'
// import OrderList from "../views/OrderList.vue";
import Store from '@/store/index.js'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'login',
		component: Login
	},
	{
		path: '/sales',
		name: 'sales',
		// component: Sales,
		component: () => import('../views/SalesUpdate.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/backdate',
		name: 'backdate',
		// component: Sales,
		component: () => import('../views/SalesUpdate.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/orders',
		name: 'orderList',
		// component: OrderList,
		component: () => import('../views/OrderList.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/products',
		name: 'productsList',
		// component: OrderList,
		component: () => import('../views/ProductsList.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/logout',
		name: 'logout',
		component: Logout
	},
	{
		path: '/settings',
		name: 'settings',
		component: () => import('../views/Settings.vue')
	},
	{
		path: '/export-orders',
		name: 'exportOrders',
		component: () => import('../views/ExportOrders.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/export-products',
		name: 'exportProducts',
		component: () => import('../views/ExportProducts.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/import-products',
		name: 'importProducts',
		component: () => import('../views/ImportProducts.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/check-products',
		name: 'checkProducts',
		component: () => import('../views/CheckProducts.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/check-promotions',
		name: 'checkPromotions',
		component: () => import('../views/CheckPromotions.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/update-products',
		name: 'updateProducts',
		component: () => import('../views/UpdateProducts.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/members',
		name: 'members',
		component: () => import('../views/Members.vue'),
		meta: {
			auth: true
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	if (to.name == 'settings') {
		next()
	} else if (to.meta.auth && !Store.state.auth) {
		next('/')
	} else {
		next()
	}
})

export default router
